<template>
  <div>
    <BatchTable
      :loading="loading"
      :tableData="tableData"
      ref="table"
      @checkboxChange="onTableChange"
    >
      <div slot="header" class="pt-1 pb-1">
        <el-row :gutter="10" style="display: flex;align-items: flex-end;">
          <!-- <el-col :span="12">
            <Search ref="search" @query="loadData" />
          </el-col>  -->

          <el-col :span="16">
            <Container
              v-if="chooseContainer"
              ref="container"
              @change="(e) => (containerData = e)"
              @changeBookingVolume="changeContainerData"
            />
          </el-col>
        </el-row>
      </div>
      <Footer
        slot="footer"
        class="pt-2"
        :data="footerData"
        :showContainrt="chooseContainer"
      />
    </BatchTable>
  </div>
</template>
<script>
import BatchTable from './table.vue'
// import Search from './search.vue'
import Container from './container.vue'
import Footer from './footer.vue'
import { add, multiply, round, divide } from '@/libs/util.number.js'
export default {
  components: { BatchTable, Container, Footer },
  props: {
    shipmentCode: { type: String, default: '' },
    chooseContainer: { type: Boolean, default: true },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      chooseTotal: {},
      containerData: {},
      listBox: [],
      bookingVolumeData: {},
    }
  },
  computed: {
    footerData() {
      return {
        ...this.chooseTotal,
        ...this.containerData,
        ...this.bookingVolumeData,
      }
    },
  },
  created() {
    this.loadData()
  },
  methods: {
    reload() {
      // this.$refs.search.query()
      this.loadData()
    },
    reset() {
      this.$refs.table.clearCheckboxRow()
      this.chooseTotal = {}
      this.listBox = []
    },
    loadData() {
      if (!this.shipmentCode) return
      this.loading = true
      this.$api
        .shipmentBatchListByChooseApi({
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.loading = false
          if (res.body.data) {
            res.body.data.forEach((e) => {
              e.containerBoxQty = e.notInBoxQty
            })
          }
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    onTableChange(e) {
      this.listBox = e || []
      this.updateBookingVolume()
      if (!e || !e.length) {
        this.chooseTotal = {}
        return
      }
      this.chooseTotal = e.reduce(
        (
          result,
          {
            containerBoxQty,
            boxNetWeight,
            boxGrossWeight,
            boxPriceAmount,
            boxSalePriceAmount,
            boxGoodsQty,
            boxLength,
            boxWidth,
            boxHeight,
          }
        ) => {
          result.containerBoxQty = add(result.containerBoxQty, containerBoxQty)
          result.containerBoxVolume = add(
            result.containerBoxVolume,
            round(
              divide(
                multiply(
                  containerBoxQty,
                  multiply(multiply(boxLength, boxWidth), boxHeight)
                ),
                1000000
              ),
              3
            )
          )
          result.containerNetWeight = add(
            result.containerNetWeight,
            multiply(containerBoxQty, boxNetWeight)
          )
          result.containerGrossWeight = add(
            result.containerGrossWeight,
            multiply(containerBoxQty, boxGrossWeight)
          )
          result.containerPriceAmount = add(
            result.containerPriceAmount,
            multiply(containerBoxQty, boxPriceAmount)
          )
          result.containerSalePriceAmout = add(
            result.containerSalePriceAmout,
            multiply(containerBoxQty, boxSalePriceAmount)
          )
          result.boxGoodsQty = add(
            result.boxGoodsQty,
            multiply(containerBoxQty, boxGoodsQty)
          )
          return result
        },
        {
          containerBoxQty: 0,
          containerBoxVolume: 0,
          containerNetWeight: 0,
          containerGrossWeight: 0,
          containerPriceAmount: 0,
          containerSalePriceAmout: 0,
        }
      )
    },
    async getData(validate = true) {
      if (validate) {
        if (!this.listBox || !this.listBox.length) {
          this.$message({
            showClose: true,
            message:
              this.$l('INDEX.table_label_pl_select_add_data') ||
              '请选择需要添加的数据',
            type: 'warning',
          })
          return
        }

        if (
          this.chooseContainer &&
          !(await this.$refs.container.formValidate())
        ) {
          return
        }
      }

      return {
        ...this.footerData,
        listBox: this.listBox,
      }
    },
    changeContainerData(data) {
      if (data) {
        this.bookingVolumeData = JSON.parse(JSON.stringify(data))
        this.updateBookingVolume()
      } else {
        this.bookingVolumeData = {}
      }
    },
    updateBookingVolume() {
      if (this.bookingVolumeData.extendParameterType === 'LWH') {
        const length = this.bookingVolumeData.extendParameterLength
        const weight = this.bookingVolumeData.extendParameterWidth
        const height = this.bookingVolumeData.extendParameterHeight

        let containerBookingVolume = 0
        //订舱系数LWH  箱子(长+L)*(宽+W)*(高+L)保留四位 * 箱子数量 保留3位
        this.listBox.forEach((e) => {
          containerBookingVolume = add(
            containerBookingVolume,
            round(
              divide(
                multiply(
                  multiply(
                    multiply(add(e.boxLength, length), add(e.boxWidth, weight)),
                    add(e.boxHeight, height)
                  ),
                  e.containerBoxQty
                ),
                1000000
              ),
              3
            )
          )
        })
        this.bookingVolumeData.containerBookingVolume = containerBookingVolume
      }
    },
  },
}
</script>
